<template>
  <div class="game_card_outer">
    <div class="game_card_date">{{timeText}}</div>
    <div class="game_card_team_left" v-if=" innerItem.home_team != undefined && innerItem.home_team != null">
      <div>{{innerItem.home_team.name.charAt(0)}}</div>
      <div>{{innerItem.home_team.name}}</div>
    </div>
    <div class="game_card_team_vs" >
      <div>
        <img v-if="status == 0" src="../../assets/shl_home_schedule_card_vs.png" style="width: 56px;height: auto;">
        <div v-else class="game_card_teams_scores_vs">
          {{formatNumber(innerItem.home_team_score) + ' : ' + formatNumber(innerItem.away_team_score)}}
        </div>
      </div>
      <div>
        {{status == 0 ? '未开始' : (status == 1 ? '直播中' : '已结束')}}
      </div>
    </div>
    <div class="game_card_team_right" v-if=" innerItem.away_team != undefined && innerItem.away_team != null">
      <div>{{innerItem.away_team.name.charAt(0)}}</div>
      <div>{{innerItem.away_team.name}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "GameItemCard",
    props: [
      'item'
    ],
    data () {
      return {
      }
    },
    computed: {
      innerItem() {
        return this.item;
      },
      status() {
        let startedTime = this.innerItem.started_at;
        let ended_at = this.innerItem.ended_at;
        if (startedTime == undefined || ended_at == undefined) {
          return 0
        }
        let startDate = this.$moment(startedTime);
        let endDate = this.$moment(this.innerItem.ended_at);

        if (!startDate.isValid() || !endDate.isValid()) {
          return 0;
        }

        let now = this.$moment();

        if (now - startDate < 0) {
          return 0;
        } else if (now - endDate <= 0 || ended_at == 0) {
          return 1;
        } else {
          return 2;
        }

      },
      timeText() {
        let startDate = this.$moment(this.innerItem.started_at);
        // let endDate = this.$moment(this.innerItem.end_at);
        if (!startDate.isValid()) {
          return '数据有误';
        }
        let group = this.innerItem.group;
        return startDate.format('yyyy.MM.DD HH:mm') + '—' + group;
      }
    },
    methods: {
      formatNumber(number) {
        if (number >= 10) {
          return number;
        }
        if (number < 0) {
          return number;
        }
        return '0' + number;
      },

      updateStatus() {
        let width = $('#game_card_outer').width();
        if (width >= 580) {
          this.centerValue = true;
        } else {
          this.centerValue = false;
        }
      }
    },
    mounted() {



    },
    created() {
      // $(this).ready(function () {
      //   let temp = $('.game_card_outer');
      //   let width = temp.width();
      //   // console.log(width);
      //   temp.height(Math.round(width * 0.5));
      // })
    },

  }
</script>

<style scoped>
  .game_card_outer {
    width: 260px;
    height: 130px;
    background-image: url("../../assets/shl_home_schedule_card_bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
    overflow: hidden;
    mask-clip: border-box;
    -ms-interpolation-mode: bicubic;
  }


  .game_card_date {
    text-align: center;
    margin-top: 15px;
    /*padding-top: 10px;*/
    color: white;
    /*font-size: 0.8rem;*/
    font-weight: bold;
  }
  .game_card_title {
    text-align: center;
    margin-right: 8px;
    margin-left: 8px;
    color: white;
    font-weight: bold;
    font-size: 1rem;
    letter-spacing: 1.5px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .game_card_team_left, .game_card_team_right, .game_card_team_vs {
    position: absolute;

  }

  .game_card_team_left {
    left: 21%;
    top: 33%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .game_card_team_right {
    right: 21%;
    top: 33%;
    transform: translateX(50%);
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .game_card_team_left > div:first-child, .game_card_team_right > div:first-child {
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border-radius: 25px;
    border: solid 1px transparent;
    font-size: 1.5rem;
  }

  .game_card_team_left > div:first-child {
    background-color: rgb(221,119,73);
    color: white;
  }

  .game_card_team_right > div:first-child {
    background-color: rgb(222, 164, 77);
    color: rgb(197, 8, 50);
  }

  .game_card_team_left > div:last-child, .game_card_team_right > div:last-child {
    color: white;
    font-size: 0.8rem;
    font-weight: bold;
    margin-top: 10px;
    text-align: center;
  }

  .game_card_team_vs {
    left: 32%;
    top: 35%;
    width: 36%;
  }
  .game_card_team_vs > div:first-child {
    height: 50px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .game_card_team_vs > div:last-child {
    color: white;
    font-size: 0.8rem;
    text-align: center;
    font-weight: bold;
  }

  .game_card_teams_scores_vs {
    color: white;
    font-weight: bold;
    font-size: 1.5rem;
  }

</style>




// WEBPACK FOOTER //
// src/pages/outer-matches/GameItemCard.vue